var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebchat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 5.3335C27.3739 5.3335 28.0522 5.61445 28.5523 6.11454C29.0524 6.61464 29.3333 7.29292 29.3333 8.00016V21.3335C29.3333 22.8135 28.1467 24.0002 26.6667 24.0002H32V26.6668H0V24.0002H5.33333C4.62609 24.0002 3.94781 23.7192 3.44772 23.2191C2.94762 22.719 2.66667 22.0407 2.66667 21.3335V8.00016C2.66667 6.52016 3.85333 5.3335 5.33333 5.3335H26.6667ZM26.6667 8.00016H5.33333V21.3335H26.6667V8.00016ZM16 16.0002C18.9467 16.0002 21.3333 17.2002 21.3333 18.6668V20.0002H10.6667V18.6668C10.6667 17.2002 13.0533 16.0002 16 16.0002ZM16 9.3335C16.7072 9.3335 17.3855 9.61445 17.8856 10.1145C18.3857 10.6146 18.6667 11.2929 18.6667 12.0002C18.6667 12.7074 18.3857 13.3857 17.8856 13.8858C17.3855 14.3859 16.7072 14.6668 16 14.6668C14.52 14.6668 13.3333 13.4802 13.3333 12.0002C13.3333 10.5202 14.5333 9.3335 16 9.3335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebchat);
export default __webpack_public_path__ + "static/media/webchat.d59a71555326c7858d70eef332fda378.svg";
export { ForwardRef as ReactComponent };